import { Injectable } from "@angular/core";
import { RestService } from "../../core/core/rest.service";
import { Observable, of } from "rxjs";
import { DashboardObjects, DashboardShortcut } from "./dashboard-items.model";

@Injectable()
export class DashboardItemsRestService {
  private GetDashboardItemsPath = 'api/dashboard/getItems';
  private AddDashboardShortcutPath = 'api/dashboard/addShortcut';
  private RemoveDashboardShortcutPath = 'api/dashboard/removeShortcut/';

  constructor(private http: RestService) {
  }

  public GetDashboardItems(): Observable<DashboardObjects> {
    return this.http.get<DashboardObjects>(this.GetDashboardItemsPath);
  }

  public AddDashboardShortcut(shortcut: DashboardShortcut): Observable<number> {
    return this.http.post<number>(this.AddDashboardShortcutPath, shortcut);
  }

  public RemoveDashboardShortcut(shortcutId: number): Observable<boolean> {
    return this.http.get<boolean>(this.RemoveDashboardShortcutPath + shortcutId);
  }

}